import { ICalendarDayData } from 'shared/types/bookingCalendar';

import { ITypedReduxAction } from '../../types/redux';

export enum EDailyrentBookingCalendarActionTypes {
  SetError = 'dailyrentBookingCalendar/setError',
  SetInitialLoading = 'dailyrentBookingCalendar/setInitialLoading',
  SetCalendarOpen = 'dailyrentBookingCalendar/setCalendarOpen',
  SetDates = 'dailyrentBookingCalendar/setDates',
  SetAvailabilityLoading = 'dailyrentBookingCalendar/setAvailabilityLoading',
  SetDaysAvailability = 'dailyrentBookingCalendar/setDaysAvailability',
}

export type TSetCalendarOpen = ITypedReduxAction<EDailyrentBookingCalendarActionTypes.SetCalendarOpen, boolean>;
export type TSetError = ITypedReduxAction<EDailyrentBookingCalendarActionTypes.SetError, string>;
export type TSetInitialLoading = ITypedReduxAction<EDailyrentBookingCalendarActionTypes.SetInitialLoading, boolean>;
export type TSetAvailabilityLoading = ITypedReduxAction<
  EDailyrentBookingCalendarActionTypes.SetAvailabilityLoading,
  boolean
>;
export type TSetDaysAvailability = ITypedReduxAction<
  EDailyrentBookingCalendarActionTypes.SetDaysAvailability,
  ICalendarDayData[]
>;
export type TSetDates = ITypedReduxAction<
  EDailyrentBookingCalendarActionTypes.SetDates,
  { from: string | undefined; to: string | undefined }
>;

export type TDailyrentBookingCalendarActions =
  | TSetCalendarOpen
  | TSetDaysAvailability
  | TSetInitialLoading
  | TSetAvailabilityLoading
  | TSetError
  | TSetDates;
